import { clearLocalData } from './clear';
import { dexieStorage } from './dexie-storage';

export const CACHE_OWNER_META_KEY = 'ownerUserId';

export async function getCacheOwnerUserId(): Promise<string | null> {
  return dexieStorage.getMeta(CACHE_OWNER_META_KEY);
}

export async function setCacheOwnerUserId(userId: string): Promise<void> {
  await dexieStorage.setMeta(CACHE_OWNER_META_KEY, userId);
}

/** Clears IndexedDB when the cached owner does not match the authenticated user. */
export async function ensureCacheOwner(userId: string): Promise<boolean> {
  const stored = await getCacheOwnerUserId();
  if (stored && stored !== userId) {
    await clearLocalData();
    await setCacheOwnerUserId(userId);
    return false;
  }
  if (!stored) {
    await setCacheOwnerUserId(userId);
  }
  return true;
}

export async function assertCacheOwner(): Promise<void> {
  const owner = await getCacheOwnerUserId();
  if (!owner) return;

  const userJson = localStorage.getItem('user');
  if (!userJson) {
    throw new Error('offline_cache_miss');
  }

  try {
    const user = JSON.parse(userJson) as { id?: string };
    if (!user.id || user.id !== owner) {
      throw new Error('offline_cache_miss');
    }
  } catch (err) {
    if (err instanceof Error && err.message === 'offline_cache_miss') {
      throw err;
    }
    throw new Error('offline_cache_miss');
  }
}
